import { render } from "./SkyscraperSpecs.vue?vue&type=template&id=121850e5"
import script from "./SkyscraperSpecs.vue?vue&type=script&lang=js"
export * from "./SkyscraperSpecs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__